const init = () => {
  const fadeInElms = document.querySelectorAll('.js-fadeIn');
  if(!fadeInElms.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-fadeIn');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });

  fadeInElms.forEach(elm => observer.observe(elm));
}

export {
  init
}
